import type { Task } from '@horizon/shared';
import { TaskRow } from '@/components/TaskRow';

interface TaskSectionProps {
  title: string;
  hint?: string;
  tone?: 'default' | 'attention';
  action?: React.ReactNode;
  tasks: Task[];
  today: string;
  selectedId?: string | null;
  onToggle: (task: Task) => void;
  onDefer: (task: Task) => void;
}

export function TaskSection({
  title,
  hint,
  tone = 'default',
  action,
  tasks,
  today,
  selectedId,
  onToggle,
  onDefer,
}: TaskSectionProps) {
  if (tasks.length === 0) return null;

  return (
    <section className="flex min-w-0 flex-col gap-2" aria-label={title}>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2
          className={
            tone === 'attention'
              ? 'text-sm font-medium text-near'
              : 'text-sm font-medium text-ink-2'
          }
        >
          {title}
        </h2>
        {action}
      </div>
      {hint && <p className="text-xs text-muted">{hint}</p>}
      <ul className="flex flex-col gap-2">
        {tasks.map((task) => (
          <TaskRow
            key={task.id}
            task={task}
            today={today}
            selected={selectedId === task.id}
            onToggle={onToggle}
            onDefer={onDefer}
          />
        ))}
      </ul>
    </section>
  );
}
